// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__ZGEd-","ranges":"BmiRanges_ranges__1EEt8"};